import { z } from 'zod'

import { removeCountryCode, unformatPhoneNumber } from 'src/lib/phone.utils'

export const firstNameSchema = z
  .string()
  .trim()
  .min(1, { message: 'First name is required' })

export const lastNameSchema = z
  .string()
  .trim()
  .min(1, { message: 'Last name is required' })

export const emailSchema = z.string().trim().email({ message: 'Invalid email' })

export const jobTitleSchema = z
  .string()
  .trim()
  .min(1, { message: 'Job Title is required' })

export const phoneSchema = z
  .string()
  .min(1, { message: 'Phone number is required' })
  .refine((val) => unformatPhoneNumber(removeCountryCode(val)).length === 10, {
    message: 'Number must be 10 digits',
  })

export const createEmployeeSchema = z.object({
  firstName: firstNameSchema,
  lastName: lastNameSchema,
  email: emailSchema,
  jobTitle: jobTitleSchema,
  phone: phoneSchema,
})

export const updateEmployeeSchema = z.object({
  firstName: firstNameSchema,
  lastName: lastNameSchema,
  jobTitle: jobTitleSchema,
  phone: phoneSchema,
})
